import { globalEvents, GlobalEvents } from "../../../utils"
import { stagingManager } from "../stagingdatamanager/stagingmanager"
import { wasmModule } from "../wasm/wasmModule"
import {
  IWasmMouthModule,
  EArchType,
  IWASMArchModule,
  IWASMAttachmentmodel,
} from "../../common/types"
import { IToothProperty } from "../toothmanager"

class RefinementModule {
  refinementInfo: string[]
  private _mouthModel
  get mouthModel(): IWasmMouthModule {
    return this._mouthModel
  }

  openRefinementModule(isOpen: boolean) {
    if (!wasmModule.isFinishedOpencase) return
    console.log("openHistoryModule")
    wasmModule.moduleManager.SwitchRefinementDisplayModule(isOpen)
    const wasmRefinementDisplayModule =
      wasmModule.moduleManager.GetRefinementDisplayModule()
  }

  changeDisplayStageValue(index: number, archTpye: number) {
    const wasmRefinementDisplayModule =
      wasmModule.moduleManager.GetRefinementDisplayModule()
    if (!wasmRefinementDisplayModule) return
    wasmRefinementDisplayModule.changeDisplayStageValue(index, archTpye)
  }

  setRefinementDisplayRange(displayRange: string) {
    const wasmRefinementDisplayModule =
      wasmModule.moduleManager.GetRefinementDisplayModule()
    if (!wasmRefinementDisplayModule) return false
    stagingManager.showRefinementHistoryRangeType = displayRange
    const res =
      wasmRefinementDisplayModule.setRefinementDisplayRange(displayRange)

    globalEvents.fire(GlobalEvents.ON_REPORT_UPDATE)

    return res
  }

  getNumberOfRefinement(archTpye: number) {
    const wasmRefinementDisplayModule =
      wasmModule.moduleManager.GetRefinementDisplayModule()
    if (!wasmRefinementDisplayModule) return 0
    return wasmRefinementDisplayModule.getRefinementCount(archTpye)
  }

  getRefinementInfo(archTpye: number) {
    const wasmRefinementDisplayModule =
      wasmModule.moduleManager.GetRefinementDisplayModule()
    if (!wasmRefinementDisplayModule) return
    const info = wasmRefinementDisplayModule.getRefinementDataInfo(
      archTpye,
      false,
    )
    this.refinementInfo = info.split(";")
    return this.refinementInfo
  }

  getCurNodes(archTpye: number) {
    const wasmRefinementDisplayModule =
      wasmModule.moduleManager.GetRefinementDisplayModule()
    if (!wasmRefinementDisplayModule) return
    const nodes = wasmRefinementDisplayModule.getCurNodes(archTpye)
    return nodes
  }

  getCurStartStageIndex(archTpye: number) {
    const wasmRefinementDisplayModule =
      wasmModule.moduleManager.GetRefinementDisplayModule()
    if (!wasmRefinementDisplayModule) return
    return wasmRefinementDisplayModule.getCurStartStageIndex(archTpye)
  }

  getHistoryStageNumber(archTpye: number) {
    const wasmRefinementDisplayModule =
      wasmModule.moduleManager.GetRefinementDisplayModule()
    if (!wasmRefinementDisplayModule) return
    const maxStageNumber =
      wasmRefinementDisplayModule.getMaxHistoryStageNumber(archTpye)
    const refinmentNumber =
      wasmRefinementDisplayModule.getNumberOfRefinement(archTpye)
    return maxStageNumber - refinmentNumber + 1
  }

  undoRefinement() {
    const wasmRefinementDisplayModule =
      wasmModule.moduleManager.GetRefinementDisplayModule()
    if (!wasmRefinementDisplayModule) return
    wasmRefinementDisplayModule.undoRefinement()
  }

  getRefinementDateInfo() {
    const wasmRefinementDisplayModule =
      wasmModule.moduleManager.GetRefinementDisplayModule()
    if (!wasmRefinementDisplayModule) return {}
    const jsonStr = wasmRefinementDisplayModule.getRefinementDateInfo()
    console.log(
      "getRefinementDateInfo :",
      jsonStr,
      ", wasmRefinementDisplayModule: ",
      wasmRefinementDisplayModule,
    )
    const jsonObject = JSON.parse(jsonStr)
    console.log("getRefinementDateInfo :", jsonObject)
    return jsonObject
  }

  getDownloadDataNames(displayRange: string) {
    const wasmRefinementDisplayModule =
      wasmModule.moduleManager.GetRefinementDisplayModule()
    if (!wasmRefinementDisplayModule) return
    const res =
      wasmRefinementDisplayModule.getDownloadDataNames(displayRange)
    for (let j = 0; j < res.size(); j++) {
      const name = res.get(j)
      console.info("getDownloadDataNames :" + name)
    }
    return res
  }

  convertRefinementHistory = () => {
    return new Promise((resolve, reject) => {
      const wasmRefinementDisplayModule =
      wasmModule.moduleManager.GetRefinementDisplayModule()
      if (!wasmRefinementDisplayModule) resolve(false)
      const res = wasmRefinementDisplayModule.convertRefinementHistory()
      resolve(res)
    })
  }

  getUploadDirList() {
    const wasmRefinementDisplayModule =
      wasmModule.moduleManager.GetRefinementDisplayModule()
    if (!wasmRefinementDisplayModule) return
    const res = wasmRefinementDisplayModule.getUploadDirList()
    return res
  }

  getStageStartNumber(archTpye: number) {
    const wasmRefinementDisplayModule =
      wasmModule.moduleManager.GetRefinementDisplayModule()
    if (!wasmRefinementDisplayModule) return 0
    const res = wasmRefinementDisplayModule.getStageStartNumber(
      archTpye,
      false,
    )
    return res
  }

  getIsStartFromOne() {
    const wasmRefinementDisplayModule =
      wasmModule.moduleManager.GetRefinementDisplayModule()
    if (!wasmRefinementDisplayModule) return true
    const res = wasmRefinementDisplayModule.getIsStartFromOne()
    return res
  }

  getDetailedHistoryDateInfo() {
    const wasmRefinementDisplayModule =
      wasmModule.moduleManager.GetRefinementDisplayModule()
    const jsonStr =
      wasmRefinementDisplayModule.getDetailedHistoryDateInfo()
    console.log("getDetailedHistoryDateInfo :", jsonStr)
    const jsonObject = JSON.parse(jsonStr)
    console.log("getDetailedHistoryDateInfo :", jsonObject)
    return jsonObject
  }

  saveNewHistoryData() {
    const wasmRefinementDisplayModule =
      wasmModule.moduleManager.GetRefinementDisplayModule()
    wasmRefinementDisplayModule.saveNewHistoryData()
  }

  getRefinementArchModel(type: EArchType): IWASMArchModule {
    const wasmRefinementDisplayModule =
      wasmModule.moduleManager.GetRefinementDisplayModule()
    if (!wasmRefinementDisplayModule) return null
    this._mouthModel = wasmRefinementDisplayModule.getCurDataMouthModel()
    if (type === EArchType.UpArch) {
      if (this.mouthModel) {
        return this.mouthModel.GetArchModel(wasmModule.module.ArchType.UpArch)
      } else {
        return null
      }
    }

    if (type === EArchType.LowArch) {
      if (this.mouthModel) {
        return this.mouthModel.GetArchModel(wasmModule.module.ArchType.DownArch)
      } else {
        return null
      }
    }
  }

  getAttachmentModel(): IWASMAttachmentmodel {
    const wasmRefinementDisplayModule =
      wasmModule.moduleManager.GetRefinementDisplayModule()
    if (!wasmRefinementDisplayModule) return null
    return wasmRefinementDisplayModule.getAttachmentModel()
  }

  isToothHasBiteRamp(toothid: number): boolean {
    if (!wasmModule.isFinishedOpencase) return false
    const wasmRefinementDisplayModule =
      wasmModule.moduleManager.GetRefinementDisplayModule()
    if (!wasmRefinementDisplayModule) return false
    return wasmRefinementDisplayModule.IsHisToothHasBiteRamp(toothid)
  }

  getRefinementToothProperties(toothId: number): IToothProperty | null {
    if (!wasmModule.isFinishedOpencase) return null
    const wasmRefinementDisplayModule =
      wasmModule.moduleManager.GetRefinementDisplayModule()
    if (!wasmRefinementDisplayModule) return null
    const properties = {
      isCrown: wasmRefinementDisplayModule.getToothCrownStatus(toothId),
      isImplant:
        wasmRefinementDisplayModule.getToothImplantStatus(toothId),
      isBridge: wasmRefinementDisplayModule.getToothBridgeStatus(toothId),
      isPontic: wasmRefinementDisplayModule.getToothPonticStatus(toothId),
      isErupting: wasmRefinementDisplayModule.getToothEruptStatus(toothId),
      isPrimary:
        wasmRefinementDisplayModule.getToothPrimaryStatus(toothId),
      isExtract:
        wasmRefinementDisplayModule.getToothExtractStatus(toothId),
    }
    return properties
  }

  getRefinementToothList(): { uplist: number[]; lowlist: number[] } {
    const uplist: number[] = []
    const lowlist: number[] = []
    // if there is upper jaw
    const archModelUpper = this.getRefinementArchModel(EArchType.UpArch)
    if (archModelUpper) {
      const toothupIds = archModelUpper.GetNormalAndPulloutToothIds()
      const size = toothupIds.size()
      for (let i = 0; i < size; i++) {
        const toothid = toothupIds.get(i)
        uplist.push(toothid)
      }
      if (uplist[0] > uplist[uplist.length - 1]) {
        uplist.reverse()
      }
    }

    // if there is lower jaw
    const archModelLower = this.getRefinementArchModel(EArchType.LowArch)
    if (archModelLower) {
      const toothlowIds = archModelLower.GetNormalAndPulloutToothIds()
      const sizelow = toothlowIds.size()
      for (let i = 0; i < sizelow; i++) {
        const toothid = toothlowIds.get(i)
        lowlist.push(toothid)
      }
      if (lowlist[0] < lowlist[uplist.length - 1]) {
        lowlist.reverse()
      }
    }

    return { uplist, lowlist }
  }

  getNewRefinementInfo() {
    const wasmRefinementDisplayModule =
      wasmModule.moduleManager.GetRefinementDisplayModule()
    if (!wasmRefinementDisplayModule) return {}
    const jsonStr =
      wasmRefinementDisplayModule.getNewRefinementInfo()
    console.log("getNewRefinementInfo :", jsonStr)
    const jsonObject = JSON.parse(jsonStr)
    console.log("getNewRefinementInfo :", jsonObject)
    return jsonObject
  }

  getLastRefinementName() {
    const wasmRefinementDisplayModule =
      wasmModule.moduleManager.GetRefinementDisplayModule()
    if (!wasmRefinementDisplayModule) return ""
    const nameStr =
      wasmRefinementDisplayModule.getLastRefinementName()
    return nameStr
  }
}

export const refinementModule = new RefinementModule()
